/* eslint-disable no-nested-ternary */
import styled from 'styled-components';

import {
  Components,
} from '@powdr/constants';

// eslint-disable-next-line no-unused-vars
const CPNT = Components.DOR_MEASUREMENTS;

export const StyledDorMeasurementItem = styled.div`
  ${({ $centerItemsInColumn }) => ($centerItemsInColumn) && `
    display: flex;
    align-items: center;
    justify-content: center;
  `}

  &.mobile-grouped-item {
    .text-measurement {
      text-align: center;

      .label, .content {
        width: 100%;
      }
    }
  }
`;
